import { legendData } from '../../../services/map/layer/legend';

export const getters = {
    getMapByName: (state) => (name) => {
        name = name || state.defaultMapName;
        return state.maps.find(map => map.name === name);
    },
    getMapLayer: (state) => (mapName, layerId) => {
        mapName = mapName || state.defaultMapName;
        const map = state.maps.find(({ name }) => name === mapName);
        if (!map) {
            return false;
        }
        const mapLayer = map.layers.find(({ id }) => id === layerId);
        if (!mapLayer) {
            return false;
        }
        return mapLayer;
    },
    getMapViewPort: (state) => (mapName) => {
        mapName = mapName || state.defaultMapName;
        const map = state.maps.find(({ name }) => name === mapName);
        if (!map) {
            return false;
        }
        return map.viewport;
    },
    getMapLayerOpacity: (state, _getters) => (mapName, layerId) => {
        return _getters.getMapLayer(mapName, layerId)?.olLayer?.getOpacity();
    },
    isLayerVisibleOnMap: (state) => (mapName, layerId) => {
        mapName = mapName || state.defaultMapName;
        const map = state.maps.find(({ name }) => name === mapName);
        if (!map) {
            return false;
        }
        const mapLayer = map.layers.find(({ id }) => id === layerId);
        if (!mapLayer) {
            return false;
        }
        const whithinRange = (mapLayer?.maxResolution >= map.viewport.resolution) && (mapLayer?.minResolution <= map.viewport.resolution);
        return mapLayer.visible && whithinRange;
    },
    getMapTerms: (state) => (mapName) => {
        mapName = mapName || state.defaultMapName;
        const map = state.maps.find(_map => _map.name === mapName);
        if (!map) {
            return [];
        }
        const whithinRange = (mapLayer) => (mapLayer.visible && mapLayer?.maxResolution >= map.viewport.resolution) && (mapLayer?.minResolution <= map.viewport.resolution);
        const layerTerms = map.layers.filter(whithinRange).map(({ terms }) => terms);
        const baseLayerTerms = map.baseLayer?.terms;
        return [...layerTerms, baseLayerTerms].filter(terms => terms);
    },
    getLegendData: (state, _getters) => (mapName) => {
        mapName = mapName || state.defaultMapName;
        const map = state.maps.find(_map => _map.name === mapName);
        if (!map) {
            return [];
        }
        return legendData(_getters.getActivatedLayers, _getters.endpoint);
    },
    getWebLegendData: (state, _getters) => (mapName) => {
        mapName = mapName || state.defaultMapName;
        const map = state.maps.find(_map => _map.name === mapName);
        if (!map) {
            return [];
        }
        const orderedLegendData = legendData(_getters.getAllOrderedLayers, _getters.endpoint);
        // first alphabetically sorted feedback layers, then alphabetically sorted themelayers
        return [...orderedLegendData.filter(layer => layer.feedback), ...orderedLegendData.filter(layer => !layer.feedback)];
    },
    getViewportData: (state) => (mapName) => {
        mapName = mapName || state.defaultMapName;
        const map = state.maps.find(_map => _map.name === mapName);
        if (!map) {
            return null;
        }
        const viewportZoom = map.viewport?.zoom;
        const viewportCenter = map.viewport?.center;
        if (viewportZoom && viewportCenter) {
            return {
                center: viewportCenter,
                zoom: viewportZoom,
            };
        }
        return null;
    },
    getMap3D(state) {
        return state.map3D;
    },
    getMap3DEnabled(state) {
        return state.map3DEnabled;
    },
    getMapTooltipsEnabled: (state) => {
        return state.mapTooltipsEnabled;
    },
    getApplyingUserMap: (state) => {
        return state.applyingUserMap;
    }
};
